import { render } from "./AgendaPanel.vue?vue&type=template&id=0fa13f72"
import script from "./AgendaPanel.vue?vue&type=script&lang=js"
export * from "./AgendaPanel.vue?vue&type=script&lang=js"

import "./AgendaPanel.vue?vue&type=style&index=0&id=0fa13f72&lang=css"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__